// OfferExpired.tsx
import React from 'react';
import { Box, Typography, Button, Divider } from '@material-ui/core';
import { WhatsApp } from '@material-ui/icons';
import LogoCavca from 'assets/Branding/cavcaLogoV2.png';
import { useStyles } from './styles';

const OfferExpired = () => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100vw"
      height="100vh"
      bgcolor="background.default"
      className={classes.expiredContainer}>
      <img src={LogoCavca} alt="Logo Cavca" className={classes.expiredLogo} />

      <Typography
        variant="h4"
        color="textSecondary"
        gutterBottom
        style={{ textShadow: '1px 1px 3px rgba(0, 0, 0, 0.8)', color: '#ffffff' }}>
        ¡Tu cotización ha expirado!
      </Typography>

      <Typography
        variant="body1"
        color="textSecondary"
        align="center"
        paragraph
        className={classes.textSecondaryColor}>
        La cotización que solicitaste ha superado el tiempo límite de validez. Estás buscando un
        seguro que realmente te respalde? En Cavca Seguros somos más que una agencia, ¡somos tu
        aliado en protección! Con años de experiencia, trabajamos para ofrecerte las mejores
        opciones que se adaptan a tus necesidades y las de tu familia.
      </Typography>

      <Divider className={classes.divider} />

      <Typography
        variant="body2"
        color="textSecondary"
        align="center"
        paragraph
        className={classes.textSecondaryColor}>
        Contáctanos para asesorarte en la elección del seguro que mejor se ajuste a ti. Nuestro
        equipo está disponible para brindarte la mejor atención.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        startIcon={<WhatsApp />}
        href="https://wa.me/573188502710"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.whatsappButton}>
        Contactar a un asesor por WhatsApp
      </Button>
    </Box>
  );
};

export default OfferExpired;
